import React from 'react';
import { Steps } from '@wienenergiegithub/ui-next';

const CmsSteps = ({
  headingLevel,
  items,
  variant = 'default',
  noLine = false,
}) => (
  <Steps
    headingLevel={headingLevel}
    items={items}
    noLine={noLine}
    variant={variant}
  />
);

export default CmsSteps;
